import React from 'react';
import { Grid } from '@material-ui/core';
import { SelectInput } from './style';

const AddTemplate = ({ formData, setFormData, match, templates, loadTemplate }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SelectInput
          native
          disabled={match}
          variant="outlined"
          value={formData?.channel || ''}
          onChange={(e) => {
            loadTemplate(e.target.value);
            setFormData({ ...formData, channel: e.target.value });
          }}
          inputProps={{
            name: 'Grupo',
          }}
        >
          <option aria-label="None" value="">
            Canal?
          </option>
          {templates.map((i) => {
            return (
              <option key={i.id} value={i.id}>
                {i.title}
              </option>
            );
          })}
        </SelectInput>
      </Grid>
    </Grid>
  );
};

export default AddTemplate;
